import hydrate from '../common/hydrate';
import CommonSmartBanner from './components/CommonSmartBanner';
import { root, name } from './manifest.json';
hydrate(CommonSmartBanner, root, name);
if (module.hot) {
    module.hot.accept();
}
